/**
 * Checks whether the charm ID represents a PPFC icon
 */
export default function isCelebrationEvent(charmId: number): boolean {
    switch (charmId) {
        //Cake charm ID
        case 26:
        //Gym charm ID
        case 46:
        //Sprint charm ID
        case 53:
        //Todo charm ID
        case 55:
        //Exam charm ID
        case 57:
        //Goal charm ID
        case 58:
            return true;
        default:
            return false;
    }
}
